import { combineReducers } from 'redux';
import blockchainReducer from './blockchain/blockchainReducer';
import globalsReducer from './globals/globals.reducer';

export default combineReducers({
	globals: globalsReducer,
	blockchain: blockchainReducer,
});
